import bgPopup from "../../../img/bgPopup.svg";

export default function PopUpTemplate({ children }) {
  return <div className="custom-popup">{children}</div>;
}
